(function () {
  var root = document.documentElement;
  var body = document.body;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.getElementById('MainContent');

  /* ---------- Transparent header over the homepage hero and collection banners ---------- */
  var header = document.getElementById('shopify-section-header');
  var firstSection = main ? main.querySelector('.shopify-section') : null;
  var heroFirst = firstSection && firstSection.querySelector('.hm-hero, .hm-colhero');
  var overlayPage = body && (body.classList.contains('template-index') || body.classList.contains('template-collection'));
  if (overlayPage && header && heroFirst) {
    root.classList.add('hm-overlay');
    var ticking = false;
    var limit = function () { return Math.max(80, header.offsetHeight); };
    var update = function () {
      ticking = false;
      root.classList.toggle('hm-overlay--solid', window.pageYOffset > limit());
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Mobile sticky "add to bag" bar on product pages ---------- */
  (function () {
    if (!body || !body.classList.contains('template-product') || !main) return;
    var form = main.querySelector('.product-section form.product-single__form');
    if (!form) return;
    var btn = form.querySelector('.add-to-cart');
    if (!btn) return;
    var titleEl = main.querySelector('.product-section .product-single__title');
    var priceEl = main.querySelector('.product-section .product__price:not(.product__price--compare)');

    var bar = document.createElement('div');
    bar.className = 'hm-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="hm-sticky-atc__info"><span class="hm-sticky-atc__name"></span><span class="hm-sticky-atc__price"></span></div><button type="button" class="hm-sticky-atc__btn" tabindex="-1"></button>';
    var nameEl = bar.querySelector('.hm-sticky-atc__name');
    var pEl = bar.querySelector('.hm-sticky-atc__price');
    var sBtn = bar.querySelector('.hm-sticky-atc__btn');
    nameEl.textContent = titleEl ? titleEl.textContent.trim() : '';
    function sync() {
      if (priceEl) pEl.textContent = priceEl.textContent.trim();
      sBtn.textContent = btn.textContent.trim();
      sBtn.disabled = btn.disabled;
    }
    sync();
    document.body.appendChild(bar);
    sBtn.addEventListener('click', function () { btn.click(); });
    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      mo.observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
      if (priceEl) mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    if ('IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var shown = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', shown);
          bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
          sBtn.tabIndex = shown ? 0 : -1;
        });
      }, { threshold: 0 });
      io2.observe(btn);
    }
  })();

  /* ---------- Soft scroll reveal ---------- */
  if (reduce || !('IntersectionObserver' in window) || !main) return;
  root.classList.add('hm-reveal-on');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function mark(el, delay) {
    if (!el || el.classList.contains('hm-reveal')) return;
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.92 && r.bottom > 0) return;
    el.classList.add('hm-reveal');
    if (delay) el.style.transitionDelay = delay + 'ms';
    io.observe(el);
  }

  function scan(scope) {
    var sections = (scope || main).querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (sec.querySelector('.hm-hero, .hm-colhero, .product-section')) continue;
      var items = sec.querySelectorAll('.grid-product, .hm-stl__card, .hm-quote, .hm-craft__cell');
      if (items.length) {
        var head = sec.querySelector('.section-header, .hm-eyebrow, .hm-title, .hm-stl__media');
        mark(head, 0);
        for (var j = 0; j < items.length; j++) mark(items[j], (j % 3) * 120);
      } else {
        mark(sec.firstElementChild || sec, 0);
      }
    }
    mark(document.querySelector('.site-footer'), 0);
  }

  scan();
  window.setTimeout(function () {
    var left = document.querySelectorAll('.hm-reveal:not(.is-in)');
    for (var k = 0; k < left.length; k++) {
      var b = left[k].getBoundingClientRect();
      if (b.top < window.innerHeight) left[k].classList.add('is-in');
    }
  }, 2500);
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target; if (!t) return;
    var els = t.querySelectorAll('.hm-reveal');
    for (var m = 0; m < els.length; m++) els[m].classList.add('is-in');
  });
})();